import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import SectionServiceFill from "./SectionServiceFill/SectionServiceFill.vue";
import { Http } from "@status/codes";
import {
  SERVICES_ACCESS,
  SERVICES_CONTANTS,
  SERVICES_ORDER_TO_SHOW,
  SERVICES_TO_FILL,
  SERVICE_STATE_COLORS,
  SERVICE_STATES
} from "@/modules/Services/constants/ServicesConstants";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import { SectionGroup } from "@/modules/ServiceTemplate/models/SectionGroup";
import { PROFILE_CONSTANTS } from "../../constants/ProfileConstants";
import { GROUP_TYPE_CONSTANT } from "@/modules/WebViews/GroupTypeService/constants/GroupTypeConstant";
import { GroupResponse } from "@/modules/Services/models/GroupResponse";
import GroupServiceFill from "./GroupServiceFill/GroupServiceFill.vue";
import { NavigationGuardNext } from "vue-router";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import store from "@/store";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import { UserService } from "@/modules/User/services/UserService";

@Component({
  name: "ServicesView",
  components: {
    EmptyState,
    SectionServiceFill,
    GroupServiceFill
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class ServicesView extends Vue {
  @Prop() public userId!: string;
  @Prop() public showData!: boolean;

  @Inject() servicesService!: ServicesService;
  @Inject() userService!: UserService;

  dataToMainView!: MenuDataStructure;

  EMPTY_TITLE = PROFILE_CONSTANTS.EMPTY_TITLE_SERVICES;
  EMPTY_TEXT = PROFILE_CONSTANTS.EMPTY_TEXT_SERVICES;
  EMPTY_SERVICE_TEXT = PROFILE_CONSTANTS.SERVICE_EMPTY_TEXT;
  EMPTY_SERVICE_TITLE = PROFILE_CONSTANTS.SERVICE_EMPTY_TITLE;
  SERVICES_TITLE = SERVICES_CONTANTS.SERVICES_TITLE;
  COLORS = SERVICE_STATE_COLORS;

  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD;

  allowSend = SERVICES_TO_FILL;
  stateList = SERVICES_ORDER_TO_SHOW;
  sectionsServices: ServiceHeaderData[] = [];
  sections: SectionGroup[] = [];
  serviceCompleted = false;
  formReadOnly = false;
  loadingServices = false;
  showServices = true;
  fillByStep = false;
  loading = false;
  empty = false;
  chosenService = "";
  chosenServiceType = "";

  playbook = "";
  groups: GroupResponse[] = [];
  groupId = "";
  sessionId = "";
  sessionTemplateId = "";
  formsSaved: string[] = [];
  serviceTemplateVersion = 0;
  versionedService = false;
  lastSessionTemplate = "";
  lastGroupServiceKey = "";

  async mounted() {
    window.addEventListener("message", this.eventListenerIntelliticks);
  }

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      (this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL ||
        this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PROFILE) &&
      this.dataToMainView.type == PANEL_INFO_CONSTANTS.TYPE.SERVICE &&
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.FILL
    ) {
      this.getServiceData(
        this.dataToMainView.data.id,
        this.dataToMainView.data.type
      );
    }
  }

  async getServiceData(id: string, type: string) {
    this.cleanData();
    try {
      this.loading = true;
      this.showServices = false;
      this.chosenService = id;
      this.chosenServiceType = type;
      this.empty = false;

      const query = {
        serviceId: id,
        userId: this.userId,
        type
      };

      const respondeData = await this.servicesService.getServiceData(query);

      if (respondeData.code === Http.Found && respondeData.data) {
        this.serviceCompleted = this.allowSend.includes(
          respondeData.data.serviceState as string
        )
          ? false
          : true;
        this.sections = respondeData.data.sections ?? [];
        this.groups = respondeData.data.groups ?? [];
        this.fillByStep = respondeData.data?.fillByStep as boolean;
        if (
          respondeData.data.serviceState == SERVICE_STATES.COMPLETED ||
          respondeData.data.serviceState == SERVICE_STATES.CANCELED
        ) {
          this.formReadOnly = true;
          this.serviceCompleted = true;
          this.empty =
            !respondeData.data.progress || respondeData.data.progress == 0
              ? true
              : false;
        }
        this.serviceTemplateVersion =
          respondeData.data && respondeData.data.version
            ? respondeData.data.version
            : 1;
        if (respondeData.data.serviceVersion) {
          this.versionedService = true;
          const serviceVersion = respondeData.data.serviceVersion;
          this.sections.forEach(section => {
            if (section.formTemplates && section.formTemplates.length > 0)
              (section.formTemplates as SectionGroupDetail[]).forEach(
                formTemplate => {
                  if (serviceVersion.sections)
                    formTemplate.version =
                      serviceVersion.sections[section.key][formTemplate.id];
                }
              );
          });
        }
      } else {
        this.showServices = true;
        Snackbar.popInfo(respondeData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.showServices = true;
      Snackbar.popError(errorMessage);
    }
    this.loading = false;
  }

  eventListenerIntelliticks(event: { origin: string; data: string }) {
    if (
      event.origin.startsWith(
        GROUP_TYPE_CONSTANT.INTELLITICKS_REQUEST_RESPONSE.INTELLITICKS_URL
      ) &&
      event.data ===
        GROUP_TYPE_CONSTANT.INTELLITICKS_REQUEST_RESPONSE.STATE_SESSION
    ) {
      this.playbookFinished();
    } else if (
      event.origin.startsWith(
        GROUP_TYPE_CONSTANT.INTELLITICKS_REQUEST_RESPONSE.INTELLITICKS_URL
      ) &&
      event.data &&
      typeof event.data === "string"
    ) {
      this.formsSaved = JSON.parse(
        (event.data as string).replace(/&quot;/g, '"')
      );
    }
    return;
  }

  async handleOperation(
    itemId: string,
    playbook: string,
    itemTemplateId: string,
    groupId: string
  ) {
    const userDocument = await this.getUserDocument(this.userId);

    this.formsSaved = [];
    this.sessionId = itemId;

    this.playbook = playbook
      .concat(`?TOKEN=${localStorage.getItem("TOKEN")}`)
      .concat(`&groupId=${groupId}`)
      .concat(`&sessionId=${this.sessionId}`)
      .concat(`&serviceId=${this.chosenService}`)
      .concat(`&patientId=${this.userId}`)
      .concat(`&userId=${localStorage.getItem("UID")}`)
      .concat(`&sessionTemplateId=${itemTemplateId}`)
      .concat(`&versionTemplate=${this.serviceTemplateVersion}`)
      .concat(`&userDocument=${userDocument}`)
      .concat(`&platform_root=${true}`);
  }

  playbookFinished() {
    this.cleanDataPlayBookEnd();
    this.refreshServices();
    store.commit(STORE_CONSTANTS.REFRESH_GROUP_SERVICE, true);
    Snackbar.popInfo(GROUP_TYPE_CONSTANT.VIEW_INTELLITICKS.FORM_SAVE);
  }

  cleanData() {
    this.playbook = "";
    this.groups = [];
    this.fillByStep = false;
    this.formReadOnly = false;
    this.groupId = "";
    this.sessionId = "";
    this.formsSaved = [];
    this.sections = [];
  }

  cleanDataPlayBookEnd() {
    this.playbook = "";
    this.fillByStep = false;
    this.groupId = "";
    this.sessionId = "";
    this.formsSaved = [];
    this.sections = [];
  }

  refreshServices() {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
      type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
      action: PANEL_INFO_CONSTANTS.ACTION.REFRESH
    });
  }

  prepareToExit(next: NavigationGuardNext) {
    if (this.$refs.serviceGroupComponent) {
      (this.$refs.serviceGroupComponent as Vue & {
        prepareToExit: (next: NavigationGuardNext) => void;
      }).prepareToExit(next);
    } else {
      next();
    }
  }

  async refreshServiceData({
    serviceId,
    type
  }: {
    serviceId: string;
    type: string;
  }) {
    if (!this.versionedService) await this.getServiceData(serviceId, type);
  }

  async getUserDocument(userId: string) {
    try {
      const response = await this.userService.getUserBasicInfo(userId);
      if (response.code === Http.Found) {
        return response.data?.userDocument;
      }
      return undefined;
    } catch (error) {
      return undefined;
    }
  }
}
